import _defineProperty from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { POSITION_SCALE_CHANNELS } from '../../../channel';
import { hasContinuousDomain } from '../../../scale';
import { keys } from '../../../util';
import { getMarkPropOrConfig, signalOrValueRef } from '../../common';
import { fieldInvalidPredicate } from './valueref';
export function defined(model) {
  var config = model.config,
      markDef = model.markDef;
  var invalid = getMarkPropOrConfig('invalid', markDef, config);

  if (invalid) {
    var signal = allFieldsInvalidPredicate(model, {
      channels: POSITION_SCALE_CHANNELS
    });

    if (signal) {
      return {
        defined: {
          signal: signal
        }
      };
    }
  }

  return {};
}

function allFieldsInvalidPredicate(model, _ref) {
  var _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      channels = _ref.channels;
  var filterIndex = channels.reduce(function (aggregator, channel) {
    var scaleComponent = model.getScaleComponent(channel);

    if (scaleComponent) {
      var scaleType = scaleComponent.get('type');
      var field = model.vgField(channel, {
        expr: 'datum'
      }); // While discrete domain scales can handle invalid values, continuous scales can't.

      if (field && hasContinuousDomain(scaleType)) {
        aggregator[field] = true;
      }
    }

    return aggregator;
  }, {});
  var fields = keys(filterIndex);

  if (fields.length > 0) {
    var op = invalid ? '||' : '&&';
    return fields.map(function (field) {
      return fieldInvalidPredicate(field, invalid);
    }).join(" ".concat(op, " "));
  }

  return undefined;
}

export function valueIfDefined(prop, value) {
  if (value !== undefined) {
    return _defineProperty({}, prop, signalOrValueRef(value));
  }

  return undefined;
}